var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedGreenCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 9.03757 8.53757 11.5 5.5 11.5C2.46243 11.5 0 9.03757 0 6C0 2.96243 2.46243 0.5 5.5 0.5C8.53757 0.5 11 2.96243 11 6ZM8.27085 3.91665C8.06948 3.71528 7.74301 3.71528 7.54164 3.91665C7.53678 3.92151 7.53221 3.92666 7.52797 3.93207L5.14071 6.97401L3.70142 5.53472C3.50005 5.33335 3.17358 5.33335 2.97221 5.53472C2.77085 5.73608 2.77085 6.06256 2.97221 6.26392L4.79164 8.08335C4.99301 8.28472 5.31948 8.28472 5.52085 8.08335C5.52533 8.07887 5.52956 8.07414 5.53353 8.06919L8.27817 4.63839C8.47218 4.4365 8.46974 4.11554 8.27085 3.91665Z",
    fill: "#14BF86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedGreenCircle);
export default __webpack_public_path__ + "static/media/checked-green-circle.2aeb5d0219f4741aa4c380b858907aca.svg";
export { ForwardRef as ReactComponent };